import React from 'react';
import './BMIChart.css'; // Separate CSS file for styling
const bmiData = [
    { bmi: '≤ 18.4', category: 'Underweight' },
    { bmi: '18.5 - 24.9', category: 'Normal' },
    { bmi: '25.0 - 39.9', category: 'Overweight' },
    { bmi: '≥ 40.0', category: 'Obese' }
];

const BMICategories = () => {
    return (
        <div className="bmi-categories-container" id="bmi-categories">
            <h2>BMI Categories</h2>
            <div className="bmi-categories-grid">
                {bmiData.map((item, index) => (
                    <div key={index} className="bmi-category-item">
                        <div className="bmi-value">{item.bmi}</div>
                        <div className="bmi-category">{item.category}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BMICategories;